/**
 * EGD — Garde-fou des tutoriels offerts (page panier).
 *
 * <egd-bonus-guard> (snippets/egd-bonus-panier.liquid) applique les corrections
 * calculées en Liquid : { "clé de ligne": quantité }, clés lues dans le rendu
 * serveur du moment (une clé change quand ses remises changent : jamais de clé
 * gardée en mémoire). Envoi par /cart/update.js, puis rechargement de la page.
 *
 * Jamais de boucle : 2 essais au maximum par session. Le compteur est gardé dans
 * sessionStorage, à défaut dans history.state ; s'il ne peut être gardé nulle
 * part, aucune correction automatique n'est tentée (le message reste affiché).
 * Dans l'éditeur de thème (Shopify.designMode), aucune correction automatique.
 * Le formulaire du rappel n'est envoyé qu'une fois (double clic sans effet).
 *
 * Ce script ne fixe jamais un prix : la gratuité vient des remises (serveur).
 * Événement Clarity sans donnée personnelle : mug_panier_repere_lot (clic sur le
 * lien du repère « formule lot », snippets/egd-cart-objet-lots.liquid).
 */
(() => {
  if (window.EgdBonusPanier) return;
  window.EgdBonusPanier = true;

  const R = window.routes || {};
  const URL_UPDATE = (R.cart_update_url || '/cart/update') + '.js';
  const K_FLASH = 'egd-bonus-flash';
  const K_ESSAIS = 'egd-bonus-essais';
  const MAX_ESSAIS = 2;

  const etat = () => {
    try {
      const s = window.history.state;
      return s && typeof s === 'object' ? s : {};
    } catch (e) {
      return {};
    }
  };

  const store = {
    get(k) {
      try {
        const v = window.sessionStorage.getItem(k);
        if (v !== null) return v;
      } catch (e) {
        /* stockage indisponible */
      }
      const s = etat();
      return Object.prototype.hasOwnProperty.call(s, k) ? String(s[k]) : null;
    },
    set(k, v) {
      try {
        window.sessionStorage.setItem(k, v);
        if (window.sessionStorage.getItem(k) === v) return true;
      } catch (e) {
        /* stockage indisponible */
      }
      try {
        const s = Object.assign({}, etat());
        s[k] = v;
        window.history.replaceState(s, '');
        return etat()[k] === v;
      } catch (e) {
        return false;
      }
    },
    del(k) {
      try {
        window.sessionStorage.removeItem(k);
      } catch (e) {
        /* stockage indisponible */
      }
      try {
        const s = etat();
        if (Object.prototype.hasOwnProperty.call(s, k)) {
          const n = Object.assign({}, s);
          delete n[k];
          window.history.replaceState(n, '');
        }
      } catch (e) {
        /* historique indisponible */
      }
    },
  };

  const clarity = (nom) => {
    try {
      if (typeof window.clarity === 'function') window.clarity('event', nom);
    } catch (e) {
      /* Clarity absent ou bloqué par le consentement */
    }
  };

  // Rappel : la liste fermée coupe « [titre] — vendu seul [prix] » ; le texte complet de
  // l'option choisie (texte rendu par le serveur, aucun montant écrit ici) est recopié
  // sous la liste. Sans JS, la ligne reste vide et masquée.
  const majChoix = (f) => {
    const sel = f && f.querySelector('select');
    const out = f && f.querySelector('[data-egd-rappel-choix]');
    if (!sel || !out) return;
    const o = sel.options[sel.selectedIndex];
    out.textContent = o ? 'Votre sélection : ' + o.text.trim() : '';
  };
  const majTousChoix = () => {
    document.querySelectorAll('form.egd-bonus-rappel').forEach(majChoix);
  };

  class EgdBonusGuard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.egdBound === '1') return;
      this.dataset.egdBound = '1';
      // Le rappel est re-rendu avec cet élément (même snippet, cart.js) : on le met à jour.
      majTousChoix();

      const flash = store.get(K_FLASH);
      if (flash) {
        store.del(K_FLASH);
        const box = this.querySelector('[data-egd-flash]');
        if (box) window.setTimeout(() => { box.textContent = flash; }, 60);
      }

      let fix = null;
      try {
        fix = JSON.parse(this.dataset.fix || '{}');
      } catch (e) {
        fix = null;
      }
      if (!fix || typeof fix !== 'object' || Object.keys(fix).length === 0) {
        if (fix) store.del(K_ESSAIS);
        return;
      }

      // Éditeur de thème : pas de correction automatique (ni écriture dans le panier, ni
      // rechargement de l'aperçu) ; le message rendu par le serveur reste affiché.
      if (window.Shopify && window.Shopify.designMode) return;

      const essais = parseInt(store.get(K_ESSAIS) || '0', 10) || 0;
      if (essais >= MAX_ESSAIS) return; // le message rendu par le serveur reste affiché
      // Sans compteur persistant, aucun rechargement automatique (jamais de boucle).
      if (!store.set(K_ESSAIS, String(essais + 1))) return;

      fetch(URL_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: fix }),
      })
        .then((r) => {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(() => {
          store.set(K_FLASH, this.dataset.message || 'Votre panier a été mis à jour.');
          window.location.reload();
        })
        .catch(() => {
          window.location.reload();
        });
    }
  }

  if (!customElements.get('egd-bonus-guard')) customElements.define('egd-bonus-guard', EgdBonusGuard);

  // Après une correction qui a retiré toutes les lignes offertes (par exemple :
  // plus de mug au panier), le snippet ne rend plus rien : le message est alors
  // affiché ici, et le compteur est remis à zéro.
  // Panier devenu vide : le pied du panier est masqué (.is-empty .cart__footer,
  // component-cart.css), le message va donc au-dessus de « Votre panier est vide »
  // (.cart__warnings, visible en état vide). Sinon : en tête du bloc « sous-total ».
  if (!document.querySelector('egd-bonus-guard')) {
    store.del(K_ESSAIS);
    const flash = store.get(K_FLASH);
    if (flash) {
      store.del(K_FLASH);
      const vide = document.querySelector('cart-items.is-empty .cart__warnings');
      const hote =
        vide ||
        document.querySelector('#main-cart-footer:not(.is-empty) .js-contents') ||
        document.getElementById('cart-errors');
      if (hote) {
        const p = document.createElement('p');
        p.className = 'egd-bonus-flash';
        p.setAttribute('role', 'status');
        p.style.cssText =
          'max-width:38rem;margin:0 auto 1.2rem;padding:1rem 1.2rem;border-radius:1rem;font-size:1.4rem;' +
          'line-height:1.45;text-align:left;background:#f1f6f2;border:1px solid #c9dccf;color:#1f3a2b;';
        hote.insertBefore(p, hote.firstChild);
        window.setTimeout(() => { p.textContent = flash; }, 60);
      }
    }
  }

  // Repère « formule lot » : délégation (les lignes sont re-rendues par cart.js).
  document.addEventListener('click', (e) => {
    const lien = e.target && e.target.closest ? e.target.closest('[data-egd-repere-lot]') : null;
    if (lien) clarity('mug_panier_repere_lot');
  });

  // Rappel « Ajouter mon tutoriel offert » : un seul envoi par formulaire (un double
  // clic créerait une ligne en quantité 2). Le 1er envoi natif n'est jamais bloqué.
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f || !f.classList || !f.classList.contains('egd-bonus-rappel')) return;
    if (f.dataset.egdEnvoi === '1') {
      e.preventDefault();
      return;
    }
    f.dataset.egdEnvoi = '1';
  });

  document.addEventListener('change', (e) => {
    const sel = e.target;
    if (sel && sel.id === 'EgdBonusRappel' && sel.form) majChoix(sel.form);
  });

  // Affichage de la page (y compris retour arrière) : la sélection restaurée par le
  // navigateur est recopiée ; depuis le cache, le formulaire redevient utilisable.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      document.querySelectorAll('form.egd-bonus-rappel[data-egd-envoi]').forEach((f) => {
        delete f.dataset.egdEnvoi;
      });
    }
    majTousChoix();
  });
})();
